import './SupportFrame.scss';

export type SupportFrameTone = 'view' | 'control';

export interface ISupportFrameProps {
    /** `view` — экран смотрят (primary, 3 px), `control` — управляют или вошли от имени (warning, 4 px) */
    tone: SupportFrameTone;
}

/** Рамка по периметру окна на время сеанса поддержки: поверх содержимого, клики проходят насквозь. */
const SupportFrame = ({ tone }: ISupportFrameProps) => (
    <div
        className={`support-frame support-frame--${tone}`}
        aria-hidden
        data-remote-control-exclude
        data-testid="support-frame"
        data-tone={tone}
    />
);

export default SupportFrame;
